import { CFParticipant } from '../participants/cf-participant';

export class CFSignatureForInit {
    constructor(
        public signatureType: number,
        public requester: CFParticipant,
        public signer: CFParticipant
    ) {}
}
